import { styled } from '@mui/system';
import Box from '@mui/material/Box';
export const FeatureItem = styled(Box)({
  borderBottom: '1px dotted',
  borderBottomColor: '#949494',
  fontSize: '13px',
});